export type AllocationDocumentEntryType =
  | 'BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO'
  | 'BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO_MH'
  | 'BUT_TOAN_HUY'
  | 'CHUNG_TU_PHAI_THU_KHAC_CHUNG_TU_BU_TRU_CONG_NO'
  | 'CHUNG_TU_PHAI_TRA_KHAC'
  | 'GIAY_BAO_CO'
  | 'GIAY_BAO_NO'
  | 'HOA_DON_BAN_DICH_VU'
  | 'HOA_DON_BAN_HANG'
  | 'HOA_DON_DICH_VU_TRA_LAI_GIAM_GIA'
  | 'HOA_DON_DICH_VU_TRA_LAI_NHA_CUNG_CAP'
  | 'HOA_DON_DIEU_CHINH_GIA_HANG_BAN'
  | 'HOA_DON_MUA_DICH_VU'
  | 'HOA_DON_MUA_HANG_TRONG_NUOC'
  | 'PHIEU_CHI'
  | 'PHIEU_KE_TOAN'
  | 'PHIEU_KE_TOAN_THEO_NGHIEP_VU'
  | 'PHIEU_NHAP_CHI_PHI_MUA_HANG'
  | 'PHIEU_NHAP_DIEU_CHINH_GIA_HANG_MUA'
  | 'PHIEU_NHAP_DIEU_CHUYEN'
  | 'PHIEU_NHAP_HANG_BAN_TRA_LAI'
  | 'PHIEU_NHAP_KHO'
  | 'PHIEU_THANH_TOAN_TAM_UNG'
  | 'PHIEU_THU'
  | 'PHIEU_XUAT_DIEU_CHUYEN'
  | 'PHIEU_XUAT_KHO'
  | 'PHIEU_XUAT_TRA_LAI_NHA_CUNG_CAP';

export interface AllocationDocumentEntryState {
  documentUuid: string;
  documentType: AllocationDocumentEntryType;
}

export interface AllocationDocumentRow {
  document_type?: string;
  document_uuid?: string;
}

const DOCUMENT_ENTRY_TYPES = new Set<AllocationDocumentEntryType>([
  'BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO',
  'BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO_MH',
  'BUT_TOAN_HUY',
  'CHUNG_TU_PHAI_THU_KHAC_CHUNG_TU_BU_TRU_CONG_NO',
  'CHUNG_TU_PHAI_TRA_KHAC',
  'GIAY_BAO_CO',
  'GIAY_BAO_NO',
  'HOA_DON_BAN_DICH_VU',
  'HOA_DON_BAN_HANG',
  'HOA_DON_DICH_VU_TRA_LAI_GIAM_GIA',
  'HOA_DON_DICH_VU_TRA_LAI_NHA_CUNG_CAP',
  'HOA_DON_DIEU_CHINH_GIA_HANG_BAN',
  'HOA_DON_MUA_DICH_VU',
  'HOA_DON_MUA_HANG_TRONG_NUOC',
  'PHIEU_CHI',
  'PHIEU_KE_TOAN',
  'PHIEU_KE_TOAN_THEO_NGHIEP_VU',
  'PHIEU_NHAP_CHI_PHI_MUA_HANG',
  'PHIEU_NHAP_DIEU_CHINH_GIA_HANG_MUA',
  'PHIEU_NHAP_DIEU_CHUYEN',
  'PHIEU_NHAP_HANG_BAN_TRA_LAI',
  'PHIEU_NHAP_KHO',
  'PHIEU_THANH_TOAN_TAM_UNG',
  'PHIEU_THU',
  'PHIEU_XUAT_DIEU_CHUYEN',
  'PHIEU_XUAT_KHO',
  'PHIEU_XUAT_TRA_LAI_NHA_CUNG_CAP'
]);

export const resolveAllocationDocumentEntry = (row: AllocationDocumentRow): AllocationDocumentEntryState | null => {
  const documentUuid = row.document_uuid?.trim();
  const documentType = row.document_type?.trim() as AllocationDocumentEntryType | undefined;

  if (!documentUuid || !documentType || !DOCUMENT_ENTRY_TYPES.has(documentType)) return null;

  return { documentUuid, documentType };
};
